import { axiosBase, errorHandler } from "./axios";

const getBatch = (data: any) => {
  return axiosBase.get("batch/list", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getBatchParams = (data: any) => {
  return axiosBase.get("batch/list", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const createBatch = (data: any) => {
  return axiosBase.post("batch/save", data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const deleteBatch = (data: any) => {
  return axiosBase.delete(`batch/delete/${data}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const toggleBatch = (data: any) => {
  return axiosBase.post(`batch/save`, data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getAvailableUsers = (data: any) => {
  return axiosBase.get("batch/available-users", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getAvailableStudents = (data: any) => {
  return axiosBase.get("batch/available-users", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const viewBatch = (id: any) => {
  console.log(`batch/view/${id}`);
  
  return axiosBase.get(`batch/view/${id}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const markAttendance = (data: any) => {
  return axiosBase.post(`batch/markStudentAttendance`, data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

export const batchService = {
  createBatch,
  getBatch,
  getBatchParams,
  deleteBatch,
  getAvailableStudents,
  toggleBatch,
  markAttendance,
  getAvailableUsers,
  viewBatch
};
